// @ts-ignore
import { BuefyConfig } from 'buefy/types/components.d';
import { PluginObject, VueConstructor } from 'vue';
import { ConfigProgrammatic } from 'buefy';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { NamedLink } from '@/ui/components/navigation/NamedLink';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faShareSquare, faPaperPlane } from '@fortawesome/free-regular-svg-icons';
import { faShareSquare as fasShareSquare, faPause, faSquare as fasSquare }
  from '@fortawesome/free-solid-svg-icons';
import {
  faAlarmClock,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowLeft,
  faBars,
  faBullhorn,
  faCalendar,
  faCheck,
  faCheckDouble,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronSquareDown,
  faCircle,
  faClock,
  faClone,
  faCog,
  faDownload,
  faEdit,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faLock,
  faMinus,
  faMinusCircle,
  faPlay,
  faPlus,
  faSave,
  faSearch,
  faSignOutAlt,
  faStars,
  faTag,
  faTasks,
  faThLarge,
  faTimes,
  faTrashAlt,
  faTrophyAlt,
  faUserCircle,
  faUserPlus,
  faUsersCog,
  faFileEdit,
  faFileExclamation,
  faBuilding,
  faQrcode,
  faLanguage,
  faList,
  faCalendarAlt,
  faHistory,
  faMapMarkerAlt,
  faUser,
  faUserTie,
  faUserFriends,
  faTags,
  faKey,
  faSensor,
  faRouter,
  faChartBar,
  faFileAlt,
  faWallet,
  faFileInvoice,
  faBook,
  faBookOpen,
  faCalendarExclamation,
  faArrowSquareUp,
  faPaperclip,
  faQuestionCircle,
  faBell,
  faPen,
  faFolder,
  faLayerGroup,
  faSitemap,
  faFlagCheckered,
  faTrophy,
  faExclamationSquare,
  faChartLine,
  faFilter,
  faHashtag,
  faTable,
  faPercent,
  faEllipsisV,
  faUpload,
  faPrint,
  faExpandArrows,
  faCopy,
  faListAlt,
  faQuestionSquare,
  faFile,
  faCheckSquare,
  faChartPie,
  faCalendarPlus,
  faCamera,
  faCommentAlt,
  faLink,
  faPhone,
  faEnvelope,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faListOl,
  faListUl,
  faRemoveFormat,
  faSparkles,
  faAlignLeft,
  faGlobe,
  faImage,
} from '@fortawesome/pro-regular-svg-icons';

import {
  faCheckCircle,
  faCheck as falCheck,
  faInfoCircle,
  faPlusSquare,
  faCloudUpload as falCloudUpload,
  faFileAlt as falFileAlt,
  faUpload as falUpload,
  faFolders,
  faStars as falStars,
  faFile as falFile,
  faHourglassHalf,
} from '@fortawesome/pro-light-svg-icons';

import {
  faMinusCircle as fasMinusCircle,
  faPlay as faPlaySolid,
  faFolder as faFolderSolid,
  faLayerGroup as faLayerGroupSolid,
  faFilter as fasFilter,
  faFlag as fasFlag,
  faGripVertical as fasGripVertical,
} from '@fortawesome/pro-solid-svg-icons';

library.add(
  faCalendarAlt,
  faCheck,
  faCog,
  faCheckDouble,
  falCheck,
  faUpload,
  falUpload,
  falCloudUpload,
  faTrashAlt,
  faPlus,
  faPlusSquare,
  faAngleUp,
  faAngleDown,
  faFolders,
  faUserPlus,
  faUsersCog,
  faEdit,
  faAngleRight,
  faAngleLeft,
  faCalendar,
  faSave,
  faArrowLeft,
  faBars,
  faBullhorn,
  faChevronRight,
  faChevronLeft,
  faChevronSquareDown,
  faCircle,
  faClock,
  faClone,
  faSearch,
  faTag,
  faTasks,
  faThLarge,
  faTimes,
  faPlay,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faDownload,
  faTrophyAlt,
  faAlarmClock,
  faUserCircle,
  faSignOutAlt,
  faChevronUp,
  faChevronDown,
  faStars,
  faInfoCircle,
  faCheckCircle,
  faMinus,
  faFileEdit,
  faBuilding,
  faLanguage,
  faLock,
  faQrcode,
  faMinusCircle,
  faList,
  faFileExclamation,
  faHistory,
  faMapMarkerAlt,
  faUser,
  faUserTie,
  faUserFriends,
  faTags,
  faKey,
  faSensor,
  faRouter,
  faChartBar,
  faFileAlt,
  falFileAlt,
  faWallet,
  faFileInvoice,
  faBook,
  faBookOpen,
  faCalendarExclamation,
  faArrowSquareUp,
  faPaperclip,
  faQuestionCircle,
  faBell,
  faPen,
  faFolder,
  faBars,
  faLayerGroup,
  faPlaySolid,
  faFolderSolid,
  faLayerGroupSolid,
  faSitemap,
  faFlagCheckered,
  faTrophy,
  faExclamationSquare,
  faChartLine,
  faFilter,
  faHashtag,
  faTable,
  faPercent,
  faShareSquare,
  faEllipsisV,
  fasMinusCircle,
  fasShareSquare,
  faPause,
  falStars,
  fasFilter,
  faExpandArrows,
  faPrint,
  faCopy,
  falFile,
  faFile,
  faListAlt,
  faQuestionSquare,
  faCheckSquare,
  faChartPie,
  faCalendarPlus,
  faHourglassHalf,
  faCamera,
  faCommentAlt,
  faLink,
  fasFlag,
  faPhone,
  faEnvelope,
  fasSquare,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faListOl,
  faListUl,
  faRemoveFormat,
  faPaperPlane,
  faSparkles,
  fasGripVertical,
  faAlignLeft,
  faGlobe,
  faImage,
);

const BuefyPlugin: PluginObject<void> = {
  install(Vue: VueConstructor) {
    // needed for buefy
    ConfigProgrammatic.setOptions({
      defaultIconPack: 'far',
      //TODO: discuss later:
      // we could have 1 component Icon and a naming convention for our icon files
      // lets say we name our files with l- prefix as l-user, l-settings, etc
      // we will check inside if we want to render just an svg image in case of l- prefix
      // or we render Buefy icon component which will be FA and named just settings, user, etc.
      // so we will have 1 entry point
      defaultIconComponent: 'font-awesome-icon',
    } as BuefyConfig);
    Vue.component('font-awesome-icon', FontAwesomeIcon);
    Vue.component('named-link', NamedLink);
  },
};

export default BuefyPlugin;
